import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'soft-sale-card',
    imports: [],
    templateUrl: './sale-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sale-card.component.css'
})
export class SaleCardComponent {}
